export enum FileSizeRestrictions /* MB */ {
  DOCUMENT_MAX = 10,
  WORK_SAMPLE_MAX = 10,
  INBOX_ATTACHMENT_MAX = 10,
}
